import React, { useEffect } from 'react';
import { Box, Button, Grid, Typography, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Admin() {
  const navigate = useNavigate();

  // Check if logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const storedUser = localStorage.getItem('userC');

    if (!isLoggedIn || !storedUser) {
      navigate('/login');
    } else {
      try {
        const userObj = JSON.parse(storedUser);
        if (!userObj.user_id) {
          throw new Error();
        }
      } catch {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userC');
        navigate('/login');
      }
    }
  }, [navigate]);

  const sections = [
    { label: 'User Management', path: '/users' },
    { label: 'Product Management', path: '/products' },
    { label: 'Order Management', path: '/orders' },
  ];

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Admin Dashboard
      </Typography>

      <Grid container spacing={3}>
        {sections.map((section) => (
          <Grid item xs={12} md={4} key={section.label}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: 'center',
                cursor: 'pointer',
                transition: '0.3s',
                '&:hover': {
                  boxShadow: 6,
                  backgroundColor: 'primary.light',
                },
              }}
              onClick={() => navigate(section.path)}
            >
              <Typography variant="h6">{section.label}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Admin;
